export default __webpack_public_path__ + "static/media/01.0fc75d3c.jpeg";